/**
 * Maps a link skill's display name to its icon asset path under `public/link-icons/` (REV3 spec).
 * Pure string transform, no derivation — kept as its own module rather than folded into
 * `lib/links.ts` so that file's roster-derivation logic stays untouched, per the REV3 spec's
 * explicit "not modified" rule. See `frontend/scripts/fetch-link-icons.mjs` for how the matching
 * PNG lands in the repo tree; that script's `slugify` MUST stay in sync with this one by hand.
 */

/** Lowercase, apostrophes dropped, everything else non-alphanumeric collapsed to one `-`. */
export function linkSkillIconSlug(skillName: string): string {
  return skillName
    .toLowerCase()
    .replace(/'/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function linkSkillIconPath(skillName: string): string {
  return `/link-icons/${linkSkillIconSlug(skillName)}.png`;
}
